document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-calculator').forEach(calc => {
    const weightInput = calc.querySelector('.calc-weight');
    const amountEl = calc.querySelector('.calc-amount');
    const daysEl = calc.querySelector('.calc-days');
    const unitEl = calc.querySelector('.calc-unit');
    const weightLabel = calc.querySelector('.calc-weight-value');
    const packLabelEl = calc.querySelector('.calc-pack-label');

    const activityButtons = calc.querySelectorAll('.calc-activity-buttons button');
    let activity = 'freizeit';


    if (!weightInput || activityButtons.length === 0) return;

    const factors = {
      freizeit: parseFloat(calc.dataset.factorFreizeit),
      sport: parseFloat(calc.dataset.factorSport),
      leistung: parseFloat(calc.dataset.factorLeistung),
    };

    const unit = calc.dataset.unit;
    const pack = parseFloat(calc.dataset.pack);
    function formatPack(pack, unit) {
  if (unit === 'ml') {
    const liters = pack / 1000;
    return (Number.isInteger(liters) ? liters : liters.toFixed(1)) + ' L';
  }
  if (unit === 'g') {
    const kg = pack / 1000;
    return (Number.isInteger(kg) ? kg : kg.toFixed(1)) + ' kg';
  }
  return pack + ' ' + unit;
}

    function update() {
      const weight = parseFloat(weightInput.value);
      const factor = factors[activity];

      if (!factor || !weight) return;

      const daily = Math.round((weight / 100) * factor);
      const days = Math.max(1, Math.floor(pack / daily));

      weightLabel.textContent = weight + ' kg';
      amountEl.textContent = daily;
      daysEl.textContent = days;
      unitEl.textContent = unit;
      if (packLabelEl) packLabelEl.textContent = formatPack(pack, unit);

    }

    weightInput.addEventListener('input', update);
    activityButtons.forEach(button => {
  button.addEventListener('click', () => {
    // aktive Optik umschalten
    activityButtons.forEach(b => b.classList.remove('active'));
    button.classList.add('active');

    // Aktivität setzen und neu berechnen
    activity = button.dataset.value;
    update();
  });
});


    update();
  });
});
